export default {
  Protect: 2,
    Construction: 3,
    ConstructionWorkItems: 4
};
